"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreemapColorStrategy = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var measure_1 = require("../_chartColoring/measure");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var TreemapColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(TreemapColorStrategy, _super);
    function TreemapColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreemapColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute, dv) {
        var colorAssignment;
        if (viewByAttribute) {
            colorAssignment = sdk_ui_vis_commons_1.getAtributeColorAssignment(viewByAttribute, colorPalette, colorMapping, dv);
        }
        else {
            var result = _super.prototype.createColorAssignment.call(this, colorPalette, colorMapping, viewByAttribute, stackByAttribute, dv);
            colorAssignment = result.outputColorAssignment;
        }
        return {
            fullColorAssignment: colorAssignment,
            outputColorAssignment: colorAssignment,
        };
    };
    return TreemapColorStrategy;
}(measure_1.MeasureColorStrategy));
exports.TreemapColorStrategy = TreemapColorStrategy;
//# sourceMappingURL=treemapColoring.js.map